import ReactDOM from "react-dom";
import App from "./app";

import { QueryClientProvider } from "react-query";
import { ConfigProvider } from "antd";
import { AuthProvider } from "./hooks/useAuth";
import { DomLoadedProvider } from "./hooks/DomLoadedContext";
import { CustomDomainProvider } from "./hooks/useCustomDomain";
import { createRoot } from "react-dom/client";
import { queryClient } from "./Utils/query";
import { HelmetProvider } from "react-helmet-async";
import { installVercelStayOnHostGuard } from "./Utils/url/vercelStayOnHostGuard";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Must run before the first render: intercepts location.href/assign/replace,
// window.open, and the Navigation API so Vercel preview deploys can never be
// redirected off-host to browsable.ai/browsable.bio/searchbubble.com (no-op
// on production/custom domains).
installVercelStayOnHostGuard();

// ReactDOM.render(
// 	<QueryClientProvider client={queryClient}>
// 		<AuthProvider>
// 			<CustomDomainProvider>
// 				<DomLoadedProvider>
// 					<ConfigProvider
// 						theme={{
// 							token: {
// 								colorPrimary: "black",
// 							},
// 						}}
// 					>
// 						<App />
// 					</ConfigProvider>
// 				</DomLoadedProvider>
// 			</CustomDomainProvider>
// 		</AuthProvider>
// 	</QueryClientProvider>,

// 	document.getElementById("root")
// );


createRoot(document.getElementById("root") as HTMLElement).render(
	<HelmetProvider>
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<CustomDomainProvider>
					<DomLoadedProvider>
						<ConfigProvider
							theme={{
								token: {
									colorPrimary: "black",
									/* Default Ant link blue → neutral (hover derives from this). */
									colorLink: "#1a1a1a",
								},
							}}
						>
							<App />
						</ConfigProvider>
					</DomLoadedProvider>
				</CustomDomainProvider>
			</AuthProvider>
		</QueryClientProvider>
	</HelmetProvider>
);

serviceWorkerRegistration.register();